import { Link } from '@trashlab/sitesapp/src/organizations/redebins/components/shared/link';
import {
  IconCheck,
  IconX,
  IconAlertTriangle,
} from '@tabler/icons-react';

const ACCEPTED_ITEMS = [
  'Furniture, clothing, toys, packaging, general household items',
  'Construction and demolition debris: siding, cabinetry, lumber, drywall, windows, carpet, flooring',
  'Concrete, asphalt, brick (5YD only, ¾ full)',
  'Mattresses and box springs (additional fee may apply)',
  'Roofing materials',
];

const PROHIBITED_ITEMS = [
  'Hazardous waste — oils, paints, chemicals, toxic liquids',
  'Appliances, certain electronics like TVs — these can be handled by our junk removal service or recycling partners',
  'Yard waste (w/o approval), soil, dirt, sand',
  'More than 3 tons of debris',
];

export const WeightLimitsSection = () => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-[#333333] mb-10 italic text-center">
            Weight Limits & What&apos;s Accepted
          </h2>

          {/* Weight Limits */}
          <div className="mb-12">
            <h3 className="text-xl md:text-2xl font-bold text-[#333333] mb-4">
              Weight Limits
            </h3>
            <p className="text-[#333333] leading-relaxed mb-4">
              Both the 5YD and 10YD have a maximum safe pickup weight of{' '}
              <strong>3 tons (6,000 lbs)</strong>. Most residential projects fall
              well under this — but if you&apos;re loading concrete, asphalt,
              bricks, or shingles, weight adds up fast.
            </p>
            <ul className="space-y-2">
              <li className="flex items-start gap-3">
                <IconAlertTriangle
                  size={20}
                  stroke={1.5}
                  className="text-amber-500 mt-0.5 shrink-0"
                />
                <span className="text-[#333333]">
                  <strong>Concrete, asphalt, and brick</strong> → 5YD only,
                  filled ¾ full
                </span>
              </li>
              <li className="flex items-start gap-3">
                <IconCheck
                  size={20}
                  stroke={2}
                  className="text-green-600 mt-0.5 shrink-0"
                />
                <span className="text-[#333333]">
                  <strong>Mixed household debris, furniture, drywall, lumber</strong>{' '}
                  → either size, fill to the top
                </span>
              </li>
            </ul>
            <p className="text-[#333333] mt-4">
              Not sure about your load? Use our{' '}
              <Link
                href="/debris-calculator"
                className="text-[#E31837] font-semibold hover:underline"
              >
                Debris Calculator
              </Link>{' '}
              or{' '}
              <Link
                href="/contact"
                className="text-[#E31837] font-semibold hover:underline"
              >
                contact us
              </Link>
              .
            </p>
          </div>

          {/* What Goes In / What Does NOT */}
          <div className="grid md:grid-cols-2 gap-8">
            {/* Accepted */}
            <div className="bg-white rounded-lg border border-gray-200 p-6">
              <h3 className="text-lg font-bold text-green-700 mb-4 flex items-center gap-2">
                <IconCheck size={22} stroke={2} />
                What Goes In
              </h3>
              <ul className="space-y-3">
                {ACCEPTED_ITEMS.map((item) => (
                  <li key={item} className="flex items-start gap-2">
                    <IconCheck
                      size={16}
                      stroke={2}
                      className="text-green-600 mt-1 shrink-0"
                    />
                    <span className="text-[#333333] text-sm">{item}</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Not Accepted */}
            <div className="bg-white rounded-lg border border-red-200 p-6">
              <h3 className="text-lg font-bold text-[#E31837] mb-4 flex items-center gap-2">
                <IconX size={22} stroke={2} />
                What Does NOT Go In
              </h3>
              <ul className="space-y-3">
                {PROHIBITED_ITEMS.map((item) => (
                  <li key={item} className="flex items-start gap-2">
                    <IconX
                      size={16}
                      stroke={2}
                      className="text-[#E31837] mt-1 shrink-0"
                    />
                    <span className="text-[#333333] text-sm">
                      {item.includes('junk removal service') ? (
                        <>
                          Appliances, certain electronics like TVs — these can be
                          handled by our{' '}
                          <Link
                            href="/junk-removal"
                            className="text-[#E31837] hover:underline"
                          >
                            junk removal service
                          </Link>{' '}
                          or recycling partners
                        </>
                      ) : (
                        item
                      )}
                    </span>
                  </li>
                ))}
              </ul>
              <p className="mt-4 text-sm">
                Full list:{' '}
                <Link
                  href="/prohibited-items"
                  className="text-[#E31837] font-semibold hover:underline"
                >
                  See our Do&apos;s & Don&apos;ts page →
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
